import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPost } from "api/restUtil";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { getCommaNumber, getDateStr, getDateToIsoDate, getIsoDateToDisplay, getNowTimeHm, getNowTimeHmsS, getTimeHms, getTodayStr, isEmpty, isValidDate, isValidHm } from "js/common";
import DatePickerInput from "components/input/DatePickerInput";
import TimeInput from "components/input/TimeInput";
import { getResultMsg } from "js/order";

/**
 * 배송 콜백 팝업 (출고완료, 배송완료)
 */
function DeliveryCallbackModal (props) {

	const { isOpen, modalId, onClose, initData } = props;
	const [processingDate, setProcessingDate] = useState(getTodayStr());
	const [processingTime, setProcessingTime] = useState(getNowTimeHm());
	const typeNm = useMemo(() => {
		if(initData?.type === "RELEASE_COMPLETION") return "출고완료";
		else if(initData?.type  === "DELIVERY_COMPLETION") return "배송완료";
		else return "";
	}, [initData?.type]);
	
	
	useEffect(() => {
		if(isOpen) {
			setProcessingDate(getTodayStr());
			setProcessingTime(getNowTimeHm());
		}
	}, [isOpen]);

	// 배송 콜백 처리
	const onClickOk = async () => {
		
		if(isEmpty(processingDate) || isEmpty(processingTime)) {
			alert("처리 일시를 입력해 주세요.");
			return;
		}

		if(!isValidDate(processingDate) || !isValidHm(processingTime)) {
			alert("날짜/시간 형식이 올바르지 않습니다.");
			return;
		}

		let processingDateTime = processingDate + " " + processingTime;
		processingDateTime = getDateToIsoDate(processingDateTime);

		if(!window.confirm(typeNm + " 처리 하시겠습니까?")) return;
		
		const sendParam = [{
			productOrderId: initData.productOrderId,
			marketDeliveryStatusType: initData.type,
			processingDateTime: processingDateTime,
		}];
		const result = await sendPost("/api/ordr/callback/delivery-no", sendParam);
		if(result.respCode === "SUCCESS") {
			alert("처리 되었습니다.");
			onClose("OK");
		}
	}




	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={typeNm + " 팝업"}
			id={modalId}
		>

			<div className="me-modal">
				<div className="me-modal-container" style={{width: "500px", height: "150px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{typeNm} 처리</h4>
						</div>
						<div className="me-modal-body" style={{overflowY: "auto", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="grid-table" style={{gridTemplateColumns: "1fr 3fr"}}>
								<div className="th required">처리 일시</div>
								<div className="td">
									<div style={{width: "100px", display: "inline-block"}}>
										<DatePickerInput value={processingDate} onChange={e => setProcessingDate(e.target.value)}  />
									</div>
									<div style={{width: "100px", display: "inline-block"}}>
										<TimeInput value={processingTime} onChange={e => setProcessingTime(e.target.value)} />
									</div>
								</div>
							</div>
						</div>
						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={() => onClose(null)} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={() => onClickOk()} style={{width: "100%"}} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default DeliveryCallbackModal;
